import CompanyInfoFunctional from './Components/companyInfoFunctional';
import React from 'react';
import reducer from './reducer';
import sagas from './sagas';
import { withReducer } from '@store/reducerLoader';

const CompanyInfoPage = (props) => {
	return <CompanyInfoFunctional {...props} />;
};
const ReducedScreen = withReducer('companyinfo', reducer, sagas)(CompanyInfoPage);
export default ReducedScreen;
